<template>
    <div>
        <!-- Modal Component -->
        <b-modal v-model="openModal" title="New OSHA Yearly Data" size="lg" :ok-title="btnTitle" ok-variant="success" :ok-disabled="saving" :cancel-disabled="saving" no-fade @hide="handleHide" @hidden="handleHidden" @ok="handleOk" ref="oshaModal" :no-close-on-backdrop="true" scrollable>

            <div v-if="loading" class="text-center">
                <i class="fa fa-circle-o-notch fa-spin"></i> Loading
            </div>
            <template v-else>
                <div class="form-group row">
                    <label :class="{ 'col-md-4 col-form-label text-sm-right': true, 'text-danger': errors.osha_year }">Year: <i v-if="!oshaYear.osha_year" class="fa fa-asterisk text-danger small"></i></label>
                    <div class="col-md-7">

                        <b-form-select v-model="oshaYear.osha_year" :options="years" :class="{'is-invalid': errors.osha_year}"/>

                        <span v-if="errors.osha_year" class="text-danger">
                            <span v-for="error in errors.osha_year">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group row">
                    <label :class="{ 'col-md-4 col-form-label text-sm-right': true, 'text-danger': errors.emr }">EMR: <i v-if="!oshaYear.emr" class="fa fa-asterisk text-danger small"></i></label>
                    <div class="col-md-7">

                        <b-form-input type="text" v-model="oshaYear.emr" :class="{'is-invalid': errors.emr}" placeholder="Enter Experience Modification Rate (EMR)" />

                        <span v-if="errors.emr" class="text-danger">
                            <span v-for="error in errors.emr">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group row">
                    <label :class="{ 'col-md-4 col-form-label text-sm-right': true, 'text-danger': errors.epa_state_violations }">EPA/State Violations: <i v-if="oshaYear.epa_state_violations === undefined || oshaYear.epa_state_violations === ''" class="fa fa-asterisk text-danger small"></i></label>
                    <div class="col-md-7">

                        <b-form-input type="text" v-model="oshaYear.epa_state_violations" :class="{'is-invalid': errors.epa_state_violations}" placeholder="Enter Number of EPA or State Violations" />

                        <span v-if="errors.epa_state_violations" class="text-danger">
                            <span v-for="error in errors.epa_state_violations">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group row">
                    <label :class="{ 'col-md-4 col-form-label text-sm-right': true, 'text-danger': errors.fatalities }">
                        Fatalities: <i v-if="oshaYear.fatalities === undefined || oshaYear.fatalities === ''" class="fa fa-asterisk text-danger small"></i><br>
                        <small>(from OSHA 300A - Item G)</small>
                    </label>
                    <div class="col-md-7">

                        <b-form-input type="text" v-model="oshaYear.fatalities" :class="{'is-invalid': errors.fatalities}" placeholder="Enter # of Fatalities for the Year" />

                        <span v-if="errors.fatalities" class="text-danger">
                            <span v-for="error in errors.fatalities">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div v-if="oshaYear.fatalities > 0" class="form-group row">
                    <label :class="{ 'col-md-4 col-form-label text-sm-right': true, 'text-danger': errors.cited_fatalities }">
                        Cited Fatalities: <i v-if="oshaYear.cited_fatalities === undefined || oshaYear.cited_fatalities === '' || oshaYear.cited_fatalities === null" class="fa fa-asterisk text-danger small"></i><br>
                        <small>Fatalities that resulted in an OSHA Citation</small>
                    </label>
                    <div class="col-md-7">

                        <b-form-input type="text" v-model="oshaYear.cited_fatalities" :class="{'is-invalid': errors.cited_fatalities}" placeholder="Enter # of Cited Fatalities for the Year" />

                        <span v-if="errors.cited_fatalities" class="text-danger">
                            <span v-for="error in errors.cited_fatalities">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group row">
                    <label :class="{ 'col-md-4 col-form-label text-sm-right': true, 'text-danger': errors.lost_work_days }">
                        Lost Work Day Cases: <i v-if="oshaYear.lost_work_days === undefined || oshaYear.lost_work_days === ''" class="fa fa-asterisk text-danger small"></i><br>
                        <small>(from OSHA 300A - Item H)</small>
                    </label>
                    <div class="col-md-7">

                        <b-form-input type="text" v-model="oshaYear.lost_work_days" :class="{'is-invalid': errors.lost_work_days}" placeholder="Enter Lost Work Day Cases" />

                        <span v-if="errors.lost_work_days" class="text-danger">
                            <span v-for="error in errors.lost_work_days">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group row">
                    <label :class="{ 'col-md-4 col-form-label text-sm-right': true, 'text-danger': errors.transfer_restriction_cases }">
                        Job Transfer or Restriction Cases: <i v-if="oshaYear.transfer_restriction_cases === undefined || oshaYear.transfer_restriction_cases === ''" class="fa fa-asterisk text-danger small"></i><br>
                        <small>(from OSHA 300A - Item I)</small>
                    </label>
                    <div class="col-md-7">

                        <b-form-input type="text" v-model="oshaYear.transfer_restriction_cases" :class="{'is-invalid': errors.transfer_restriction_cases}" placeholder="Enter Job Transfer or Restriction Cases" />

                        <span v-if="errors.transfer_restriction_cases" class="text-danger">
                            <span v-for="error in errors.transfer_restriction_cases">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group row">
                    <label :class="{ 'col-md-4 col-form-label text-sm-right': true, 'text-danger': errors.other_recordable_cases }">
                        Other Recordable Cases: <i v-if="oshaYear.other_recordable_cases === undefined || oshaYear.other_recordable_cases === ''" class="fa fa-asterisk text-danger small"></i><br>
                        <small>(from OSHA 300A - Item J)</small>
                    </label>
                    <div class="col-md-7">

                        <b-form-input type="text" v-model="oshaYear.other_recordable_cases" :class="{'is-invalid': errors.other_recordable_cases}" placeholder="Enter # of OSHA Recordable Cases" />

                        <span v-if="errors.other_recordable_cases" class="text-danger">
                            <span v-for="error in errors.other_recordable_cases">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group row">
                    <label :class="{ 'col-md-4 col-form-label text-sm-right': true, 'text-danger': errors.total_recordable_cases }">
                        Total Recordable Cases:<br>
                    </label>
                    <div class="col-md-7">
                        <b-form-input type="text" v-model="oshaYear.total_recordable_cases" :class="{'is-invalid': errors.total_recordable_cases}" :disabled="true" />
                        <small>This input is calculated based on other inputs</small>

                        <span v-if="errors.total_recordable_cases" class="text-danger">
                            <span v-for="error in errors.total_recordable_cases">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group row">
                    <label :class="{ 'col-md-4 col-form-label text-sm-right': true, 'text-danger': errors.hours_worked }">Employee Hours Worked: <i v-if="!oshaYear.hours_worked" class="fa fa-asterisk text-danger small"></i></label>
                    <div class="col-md-7">

                        <b-form-input type="text" v-model="oshaYear.hours_worked" :class="{'is-invalid': errors.hours_worked}" placeholder="Enter Total Employee Hours Worked" />

                        <span v-if="errors.hours_worked" class="text-danger">
                            <span v-for="error in errors.hours_worked">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group row">
                    <label :class="{ 'col-md-4 col-form-label text-sm-right': true, 'text-danger': errors.incident_rate }">
                        Recordable Incident Rate:<br>
                        <small>Formula = Total Recordable Cases x 200,000/Total Hours Worked</small>
                    </label>
                    <div class="col-md-7">
                        <b-form-input type="text" v-model="oshaYear.incident_rate" :class="{'is-invalid': errors.incident_rate}" placeholder="Enter Recordable Incident Rate" :disabled="true" />
                        <small>This input is calculated based on other inputs</small>

                        <span v-if="errors.incident_rate" class="text-danger">
                            <span v-for="error in errors.incident_rate">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group row">
                    <label :class="{ 'col-md-4 col-form-label text-sm-right': true, 'text-danger': errors.first_aid_cases }">First Aid Cases: <i v-if="oshaYear.first_aid_cases === undefined || oshaYear.first_aid_cases === ''" class="fa fa-asterisk text-danger small"></i></label>
                    <div class="col-md-7">

                        <b-form-input type="text" v-model="oshaYear.first_aid_cases" :class="{'is-invalid': errors.first_aid_cases}" placeholder="Enter # of First Aid Cases" />

                        <span v-if="errors.first_aid_cases" class="text-danger">
                            <span v-for="error in errors.first_aid_cases">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <hr>

                <div class="form-group row">
                    <label :class="{ 'col-md-4 col-form-label text-sm-right': true, 'text-danger': errors.files }">OSHA 300A Form: <i v-if="!osha_file && !oshaYear.osha_file_id" class="fa fa-asterisk text-danger small"></i></label>
                    <div class="col-md-7">

                        <b-form-file v-if="openModal" plain v-model="osha_file" :class="{'is-invalid': errors.files}"/>

                        <span v-if="errors.files" class="text-danger">
                            <span v-for="error in errors.files">{{ error }}</span>
                        </span>

                        <template v-if="oshaYear.osha_file_id">
                            <hr/>
                            <div class="mb-2">
                                <div>{{ oshaYear.osha_file.file_name }}</div>
                                <span v-if="!oshaYear.osha_file.download_only">
                                    <a :href="`/files/view/${oshaYear.osha_file.file_id}`" target="_blank">View</a>&nbsp;|&nbsp;
                                </span>
                                <a :href="`/files/download/${oshaYear.osha_file.file_id}`" target="_blank">Download</a>
                            </div>
                        </template>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {

            subcontractorId: {
                type: Number,
                default: null,
            },
        },

        data: function() {
            return {
                openModal: false,
                loading: true,
                saving: false,
                errors: {},
                oshaYear: {},
                osha_file: null,

                //Form Resources
                years: []
            }
        },

        computed: {

            btnTitle(){
                //If svaing, show indicator
                if(this.saving)
                {
                    return 'Saving...';
                }

                return 'Save OSHA Yearly Data';
            },

        },

        watch: {

            'oshaYear.fatalities': function(val){
                //Do it
                this.calcIncidentRate();
                this.calcTotalCases();

                if (val == 0)
                {
                    this.oshaYear.cited_fatalities = null;
                }
            },

            'oshaYear.lost_work_days': function(val){
                //Do it
                this.calcIncidentRate();
                this.calcTotalCases();
            },

            'oshaYear.transfer_restriction_cases': function(val){
                //Do it
                this.calcIncidentRate();
                this.calcTotalCases();
            },

            'oshaYear.other_recordable_cases': function(val){
                //Do it
                this.calcIncidentRate();
                this.calcTotalCases();
            },

            'oshaYear.hours_worked': function(val){
                //Do ti
                this.calcIncidentRate();
            },

        },

        methods: {

            calcTotalCases() {
                this.oshaYear.total_recordable_cases = +this.oshaYear.fatalities + +this.oshaYear.lost_work_days + +this.oshaYear.transfer_restriction_cases + +this.oshaYear.other_recordable_cases;
            },

            calcIncidentRate(){
                if (!this.oshaYear.hours_worked)
                {
                    this.oshaYear.incident_rate = 0;
                }
                else
                {
                    let total_cases = +this.oshaYear.fatalities + +this.oshaYear.lost_work_days + +this.oshaYear.transfer_restriction_cases + +this.oshaYear.other_recordable_cases;
                    this.oshaYear.incident_rate = ((total_cases * 200000 / this.oshaYear.hours_worked).toFixed(2));
                }
            },

            handleHide(bvEvt){

            },

            handleHidden(bvEvt){
                //Reset the values
                this.oshaYear = {};
                this.errors = {};
                this.osha_file = null;
            },

            handleOk: function(bvEvt) {
               //Stops the modal from closing
               bvEvt.preventDefault();

               //Do it
               this.saveForm();
            },

            showModal(){
                //Show ti
                this.openModal = true;
            },

            setModel(oshaYear){
                //Set the model
                this.oshaYear = JSON.parse(JSON.stringify(oshaYear));
            },

            getForm(){
                //Loading indicator
                this.loading = true;

                //Get the resources
                this.$http
                    .get('subcontractors/osha')
                    .then(response => {
                        //Set it
                        this.years = response.data.years;

                        //Loading false
                        this.loading = false;
                    });
            },

            saveForm(){
                //Reset errors
                this.errors = {};

                //Loading
                this.saving = true;

                //Send it
                this.$http
                .postWithFiles('subcontractors/osha/' + this.subcontractorId, this.oshaYear, (this.osha_file ? [this.osha_file] : []))
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('OSHA Year Saved');

                    //Emit
                    //this.$emit('modalSaved', response.data);
                    this.$store.commit('updateSafetyYear', response.data);

                    //Close the modal
                    this.$refs.oshaModal.hide();

                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //SEt the height
            //this.$refs.oshaModal.$refs.body.style['max-height'] = window.innerHeight * 0.75 + 'px';

            //Get the resources
            this.getForm();
        }
    }
</script>